// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Create: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 38" enableBackground="new 0 0 38 38" xmlSpace="preserve">
<g fill="currentColor">
	<polygon points="0.25,29.94 0.25,37.75 8.06,37.75 31.1,14.71 23.29,6.9 	"/>
	<path d="M37.15,5.73l-4.88-4.88c-0.81-0.81-2.12-0.81-2.94,0l-3.81,3.81l7.81,7.81l3.81-3.81C37.96,7.85,37.96,6.54,37.15,5.73z"/>
</g>
</svg>;
};

export default React.memo(Create);
